import Vue from 'vue'
import { format } from 'date-fns'
import numeral from 'numeral'
import { findmileageDifference, formatmileage } from '../utils/utils'

numeral.register('locale', 'bg', {
  delimiters: {
    thousands: ' ',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'K',
    million: 'M',
    billion: 'B',
    trillion: 'T'
  },
  currency: {
    symbol: 'лв'
  }
})

numeral.locale('bg')

Vue.filter('date', (date) => {
  return format(date, 'DD.MM.YYYY')
})

Vue.filter('money', (price) => {
  return numeral(price).format('0,0.00 $')
})

Vue.filter('number', (value, format = '00') => {
  return numeral(value).format(format)
})

Vue.filter('mileage', formatmileage)

Vue.filter('difference', findmileageDifference)
